import { Box, Button, Checkbox, Flex, Grid, GridItem, Image, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, Textarea, Tooltip, VStack, Input } from "@chakra-ui/react";
import MyDiv from "../../MyTeamLead/myTeamLead.style";
import { AddIcon, CheckIcon, EditIcon, RepeatIcon, SmallCloseIcon, TimeIcon, ViewIcon } from "@chakra-ui/icons";
import { CustomTable, CustomToast } from "../../../../components";
import { Column } from "../../../../components/customTable/CustomTable";
import { getStatusRank, getStatusStyle, ILead, ILeadTable } from "../../LeadPool/model";
import { useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { useAuth } from "../../../../hooks/useAuth";
import HistoryIcon from "../../../../assets/Images/history-icon.svg";
import ArrowIcon from "../../../../assets/Images/Arrow-icon.svg";
import { applyMask } from "../../../../utilities/masking";

import * as routesNames from '../../../../constant/routes'
import { useNavigate } from "react-router-dom";
import { showDateTime } from "../../../../utilities/helper";
interface Props {
  leadData: ILeadTable;
  loading: boolean;
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  loadLeads: () => void;
  pagination: {
    skip: number;
    limit: number;

  };
  pageChangeFunction: (e: { skip: number; limit: number }) => void;
  toggleReveal: (rowIndex: number, field: string) => void;
  maskText: (text?: string) => string;
  handleEditLead: (row: ILead) => void;
  handleViewLead: (lead: ILead) => void;
  handleHistoryLead: (lead: ILead) => void;
  handleSelfAssign: (leadId?: number) => void;
  selectedLeads: number[];
  toggleSelectLead: (id: number) => void;
  toggleSelectAllLeads: () => void;
  selectAllLeads: boolean;

  setIsAssignModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedLeadsData: React.Dispatch<React.SetStateAction<any[]>>;
  setSelectedLeadIds: React.Dispatch<React.SetStateAction<number[]>>;
  setSelectAllLeads: React.Dispatch<React.SetStateAction<boolean>>;
  maskingSettings: any;
  revealedField: {
    rowIndex: number | null;
    field: string | null;
  };

  revealedRow: number | null;
  canViewAllContacts: boolean;
  canViewOnlyContacts: boolean;
  canViewRowContacts: boolean;
  canHideContacts: boolean;
}

const MyTeamLeadList = ({ leadData, loading, toggleSelectAllLeads, selectAllLeads, pagination, toggleSelectLead, pageChangeFunction, toggleReveal, handleHistoryLead, handleSelfAssign, selectedLeads, setIsAssignModalOpen,
  revealedField, revealedRow, canViewAllContacts, canViewOnlyContacts, canViewRowContacts, canHideContacts,
  setSelectedLeadsData, setSelectedLeadIds,
  setSelectAllLeads,
  maskingSettings, loadLeads
}: Props) => {
  const { addToast } = CustomToast();
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<{ id: number; label: string } | null>(null);
  const [statusOptions, setStatusOptions] = useState<{ id: number; label: string }[]>([]);
  const [statusReasonOptions, setStatusReasonOptions] = useState<{ id: number; label: string }[]>([]);
  const [selectedStatusReason, setSelectedStatusReason] = useState<{ id: number; label: string } | null>(null);
  const [statusLead, setStatusLead] = useState<ILead | null>(null);
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [projectAmount, setProjectAmount] = useState("");
  const [projectDuration, setProjectDuration] = useState("");
  const [projectDurationType, setProjectDurationType] = useState<number>(2);
  const [leadDataState, setLeadData] = useState<ILeadTable>(leadData);
  const [isReassignOpen, setIsReassignOpen] = useState(false);
  const [reassignLead, setReassignLead] = useState<ILead | null>(null);
  const [userOptions, setUserOptions] = useState<{ id: number; name: string }[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [reassignNote, setReassignNote] = useState("");
  const [isMultiAssignOpen, setIsMultiAssignOpen] = useState(false);
  const [multiAssignUserId, setMultiAssignUserId] = useState<number | null>(null);
  const [multiAssignRemarks, setMultiAssignRemarks] = useState("");
  const [statusLoading, setStatusLoading] = useState(false);
  const { fetchApi } = useFetch(addToast);
  const { hasPermission } = useAuth();
  const navigate = useNavigate();
  const canView = hasPermission("MyTeamLead", "leadView");
  const canViewLeadAcceptanceHistory = hasPermission("MyTeamLead", "LeadAcceptanceHistory");
  const canUpdateLeadStatus = hasPermission("MyTeamLead", "Update Lead Status");
  // const canView = hasPermission("MyTeamLead", "seeleadlist");
  const canReassign = hasPermission("MyTeamLead", "reassign");
  const { loginObj } = useAuth();
  const [expandedFields, setExpandedFields] = useState<string[]>([]);
  const canEdit = hasPermission("MyTeamLead", "leadEdit");



  const [reassignLoading, setReassignLoading] = useState(false);
  const [multiReassignLoading, setMultiReassignLoading] = useState(false);

  const loadLeadStatusReasons = async (statusId?: number, initialReasonId?: number) => {
    if (!statusId) {
      setStatusReasonOptions([]);
      return;
    }
    const res = await fetchApi(`Dropdown/statusReason?statusId=${statusId}`, "GET", null, null);
    let options: { id: number; label: string }[] = [];
    if (res && Array.isArray(res)) {
      options = res.map((s: any) => ({
        id: s.id ?? s.statusReasonId,
        label: s.statusReason ?? s.statusReasonName ?? s.name ?? s.label,
      }));
    } else if (res && res.data && Array.isArray(res.data)) {
      options = res.data.map((s: any) => ({
        id: s.id ?? s.statusReasonId,
        label: s.statusReason ?? s.statusReasonName ?? s.name ?? s.label,
      }));
    } else {
      options = [];
    }
    setStatusReasonOptions(options);
    if (initialReasonId) {
      const found = options.find((o) => o.id === initialReasonId);
      if (found) {
        setSelectedStatusReason(found);
      }
    }
  };

  useEffect(() => {
    if (selectedStatus?.id) {
      loadLeadStatusReasons(selectedStatus?.id);
    } else {
      setStatusReasonOptions([]);
    }
  }, [selectedStatus?.id]);


  const toggleField = (key: string) => {
    setExpandedFields((prev) =>
      prev.includes(key)
        ? prev.filter((x) => x !== key)
        : [...prev, key]
    );
  };

  const isLeadWon = (lead: any) =>
    lead?.leadStatusId === 16 ||
    lead?.leadStatus === "Won" ||
    lead?.leadStatus?.toLowerCase() === "won";

  const handleMultiAssign = async () => {
    const validLeadIds = selectedLeads.filter((id) => {
      const lead = leadDataState.leads.find((item: any) => item.leadId === id);
      return lead ? !isLeadWon(lead) : true;
    });
    if (!multiAssignUserId || validLeadIds.length === 0 || multiReassignLoading) return;
    setMultiReassignLoading(true);
    const payload = {
      leadIds: validLeadIds,
      newAssignedUserId: multiAssignUserId,
      remarks: multiAssignRemarks,
    };

    const res = await fetchApi("MyTeamLead/ReassignMultipleLeads", "PUT", payload);

    if (res) {
      addToast({
        message: `${validLeadIds.length} lead${validLeadIds.length > 1 ? "s" : ""} reassigned successfully`,
        status: "success"
      });
      setMultiReassignLoading(false);
      loadLeads();
      setIsMultiAssignOpen(false);
      setMultiAssignUserId(null);
      setMultiAssignRemarks("");
      setSelectedLeadIds([]);
      setSelectAllLeads(false);
    }
    setMultiReassignLoading(false);
  };

  const loadLeadStatuses = async (currentStatus?: string) => {
    const res = await fetchApi("Lead/GetLeadStatuses", "GET", null, null);

    if (res) {
      let filteredStatuses = [...res];
      if (currentStatus === "Assigned") {
        filteredStatuses = filteredStatuses.filter(
          (s: any) => s.statusName !== "Assigned"
        );
      }
      if (currentStatus === "Reassigned") {
        filteredStatuses = filteredStatuses.filter(
          (s: any) =>
            s.statusName !== "Assigned" &&
            s.statusName !== "Reassigned"
        );
      }
      setStatusOptions(
        filteredStatuses.map((s: any) => ({
          id: s.id,
          label: s.statusName,
        })).sort((a: any, b: any) => getStatusRank(a.label) - getStatusRank(b.label))
      );
    }
    // if (res) {
    //   setStatusOptions(res.map((s: any) => ({ id: s.id, label: s.statusName })));
    // }
  };

  const loadTeamUsers = async () => {
    const res = await fetchApi("Dropdown/getTeamMemberForReassign", "GET", null, null);
    if (res) {
      setUserOptions(res.map((u: any) => ({ id: u.userId, name: u.userName })));
    }
  };

  const handleOpenReassignModal = (row: ILead) => {
    if (isLeadWon(row)) {
      addToast({ message: "Won leads cannot be reassigned", status: "warning" });
      return;
    }
    setReassignLead(row);
    setSelectedUserId(row.assignedToUserId ?? null);
    setReassignNote("");
    setIsReassignOpen(true);
    loadTeamUsers();
  };

  const handleReassign = async () => {
    if (!reassignLead || isLeadWon(reassignLead) || !selectedUserId || reassignLoading) return;
    setReassignLoading(true);

    const payload = {
      leadId: reassignLead.leadId,
      newAssignedUserId: selectedUserId,
      note: reassignNote,
    };

    const res = await fetchApi("MyTeamLead/ReassignLead", "PUT", payload);

    if (res) {
      addToast({ message: "Lead reassigned successfully", status: "success" });
      loadLeads();
      setIsReassignOpen(false);
      setReassignLead(null);
      setSelectedUserId(null);
      setReassignLoading(false);

      setReassignNote("");
    }
    setReassignLoading(false);


  };

  const handleUpdateStatus = async () => {
    if (!statusLead || !selectedStatus) return;

    if (statusLead.leadStatusId === selectedStatus.id) {
      addToast({
        message: "Please change the status before updating.",
        status: "warning",
      });
      return;
    }

    if (statusReasonOptions.length > 0 && !selectedStatusReason) {
      addToast({ message: "Status reason is required", status: "error" });
      return;
    }

    try {
      setStatusLoading(true);

      const payload: any = {
        leadId: statusLead.leadId,
        statusId: selectedStatus.id,
        date: selectedDate,
        description: description,
      };

      if (statusLead?.leadStatusId) {
        payload.previousStatusId = statusLead.leadStatusId;
      }

      if (selectedStatusReason?.id) {
        payload.statusReasonId = selectedStatusReason.id;
      }
      if (selectedStatusReason?.label) {
        payload.statusReason = selectedStatusReason.label;
      }

      if (selectedStatus.id === 16) {
        payload.projectAmount = Number(projectAmount);
        payload.projectDuration = Number(projectDuration);
        payload.projectDurationType = projectDurationType;
      }

      const res = await fetchApi("Lead/UpdateLeadStatus", "PUT", payload);

      if (res) {
        addToast({ message: "Status updated", status: "success" });
        setLeadData((prev) => ({
          ...prev,
          leads: prev.leads.map((lead) =>
            lead.leadId === statusLead.leadId
              ? {
                ...lead,
                leadStatusId: selectedStatus.id,
                leadStatus: selectedStatus.label,
              }
              : lead,
          ),
        }));
        setDescription("");
        setProjectAmount("");
        setProjectDuration("");
        setProjectDurationType(2);
        setSelectedStatus(null);
        setSelectedStatusReason(null);
        setStatusReasonOptions([]);
        setIsStatusOpen(false);
      }
    } finally {
      setStatusLoading(false);
    }
  };

  const handleOpenStatusModal = (row: ILead) => {
    setStatusLead(row);

    const defaultStatus = {
      id: row.leadStatusId ?? 0,
      label: row.leadStatus ?? "Lead Created",
    };
    loadLeadStatuses(row.leadStatus); // <-- pass current status

    setSelectedStatus(defaultStatus);
    if (row.statusReasonId) {
      setSelectedStatusReason({
        id: row.statusReasonId,
        label: row.statusReason || "",
      });
    } else {
      setSelectedStatusReason(null);
    }
    if (row.leadStatusId) {
      loadLeadStatusReasons(row.leadStatusId, row.statusReasonId);
    } else {
      setStatusReasonOptions([]);
    }
    setSelectedDate("");
    setDescription("");
    setProjectAmount("");
    setProjectDuration("");
    setProjectDurationType(2);
    setIsStatusOpen(true);
  };

  const handleCloseStatusModal = () => {
    setIsStatusOpen(false);
    setSelectedStatus(null);
    setSelectedStatusReason(null);
    setStatusReasonOptions([]);
    setDescription("");
    setSelectedDate("");
    setProjectAmount("");
    setProjectDuration("");
    setProjectDurationType(2);
  };




  const NavigateLeadAssesment = (lead: any) => {
    navigate(routesNames.LEADACCEPTANCEHISTORY, {
      state: {
        leadId: lead.leadId,
      },
    });
  };



  useEffect(() => {
    setLeadData(leadData);
  }, [leadData]);

  useEffect(() => {
    loadLeadStatuses();
  }, []);
  const RevealField = ({
    rowIndex,
    field,
    value,
    isExpanded = false,
    children,
  }: {
    rowIndex: number;
    field: string;
    value?: string;
    isExpanded?: boolean;
    children?: React.ReactNode;
  }) => {
    const roleId = loginObj?.roleId?.[0];
    const isSingleFieldRevealed =
      revealedField.rowIndex === rowIndex &&
      revealedField.field === field;
    const isRowRevealed =
      revealedRow === rowIndex;
    const shouldShowValue =
      canViewAllContacts ||
      isSingleFieldRevealed ||
      isRowRevealed;

    const maskType = maskingSettings[field] || "Hidden";
    const tooltipValue = shouldShowValue
      ? value
      : canHideContacts
        ? applyMask(value || "", maskType)
        : "";
    return (
      <Box position="relative">
        <Tooltip label={tooltipValue} hasArrow placement="top" isDisabled={!tooltipValue} >
          <Box
            userSelect={shouldShowValue ? "auto" : "none"}
            filter={shouldShowValue ? "none" : canHideContacts ? "none" : "blur(4px)"}
          >
            {shouldShowValue ? (
              children ? (
                children
              ) : (
                <Text
                  color="#101828"
                  whiteSpace={isExpanded ? "normal" : "nowrap"}
                  overflow={isExpanded ? "visible" : "hidden"}
                  textOverflow={isExpanded ? "unset" : "ellipsis"}
                  wordBreak="break-word"
                  className="font-poppins text_sm text_medium"
                  maxW="150px"
                  isTruncated
                >
                  {value}
                </Text>
              )
            ) : (
              <Text
                color="#101828"
                whiteSpace={isExpanded ? "normal" : "nowrap"}
                overflow={isExpanded ? "visible" : "hidden"}
                textOverflow={isExpanded ? "unset" : "ellipsis"}
                wordBreak="break-word"
                className="font-poppins text_sm text_medium"
                maxW="150px"
                isTruncated
              >
                {canHideContacts
                  ? applyMask(value || "", maskType)
                  : value}
              </Text>
            )}
          </Box>
        </Tooltip>
        {!canViewAllContacts && !shouldShowValue && !canHideContacts && (
          <Flex position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)">
            <Flex align="center" gap={1} bg="#F2F4F7" border="1px solid #E4E7EC" borderRadius="8px" px="10px" py="3px" cursor="pointer" onClick={() => toggleReveal(rowIndex, field)}>
              <Text fontSize="11px" fontWeight="600" color="#344054">
                View
              </Text>
              <ViewIcon color="#344054" boxSize={3} />
            </Flex>
          </Flex>
        )
        }

      </Box>
    );
  };

  const NavigateMyLeadEdit = (row: ILead) => {
    navigate(routesNames.MYLEADEDIT, {
      state: {
        leadId: row.leadId,
      },
    });
  };

  const hasSelectableLeads = leadDataState?.leads?.some((row: any) => !isLeadWon(row));

  return (
    <MyDiv>
      {/* LEAD LIST HEADER */}
      {/* <Flex justify="space-between" mt={6}>
        {hasPermission("MyTeamLead", "Assign Lead") && (
          <Button
            bg="#4048D6"
            color="white"
            _hover={{ bg: "#353CC4" }}
            leftIcon={<AddIcon />}
            isDisabled={selectedLeads.length === 0}
            onClick={() => {
              const selectedRows = leadData.leads.filter((lead: any) => selectedLeads.includes(lead.leadId));

              setSelectedLeadsData(selectedRows);
              setIsAssignModalOpen(true);
            }}
          >
            Generate Lead
          </Button>
        )}
      </Flex> */}

      <Flex mb={3}>
        <Button size="sm" colorScheme="purple" borderRadius="8px" leftIcon={<RepeatIcon />}
          isDisabled={selectedLeads.length === 0} onClick={() => {
            loadTeamUsers();
            setIsMultiAssignOpen(true);
          }}
        >
          Reassign {selectedLeads.length > 0 ? `(${selectedLeads.length})` : ""}
        </Button>
      </Flex>

      {/* TABLE */}
      <Grid className="grid_container">
        <GridItem colSpan={12}>
          <CustomTable value={leadDataState.leads} pagination={false} onPageChange={pageChangeFunction} rowsPerPage={pagination.limit} totalRecords={leadDataState.totalCount} loading={loading} headerTextColor="#1A202C" emptyMessage="No Data Found" getRowBgColor={(row: any) => row.isAccepted === false ? "#FFECEC" : undefined}>
            {/* S.NO */}
            <Column
              header={<Checkbox isChecked={selectAllLeads} isDisabled={!hasSelectableLeads} onChange={toggleSelectAllLeads} />}
              body={(row: any) => {
                const isWon = isLeadWon(row);
                return (
                  <Checkbox
                    cursor={isWon ? "not-allowed" : "pointer"}
                    isDisabled={isWon}
                    isChecked={selectedLeads.includes(row.leadId)}
                    onChange={() => {
                      if (isWon) return;
                      toggleSelectLead(row.leadId);

                      if (userOptions.length === 0) loadTeamUsers();
                    }}
                  />
                );
              }}
            />
            <Column header="S.No" body={(_, index) => index + 1} />

            {/* COMPANY */}
            {/* <Column header="Company" body={(row: any, index: number) => (<RevealField rowIndex={index} field="company" value={row.companyName} />)} textAlign="center" /> */}

            <Column
              header="Company"
              body={(row: any, index: number) => {
                const key = `${row.leadId}-company`;

                return (
                  <Flex align="center" justify="center">
                    <Box width="180px">
                      <RevealField rowIndex={index} field="company" value={row.companyName} isExpanded={expandedFields.includes(key)} />
                    </Box>

                    {/* <Box width="40px">
                      {row.companyName?.length > 25 && (
                        <Text color="#4048D6" fontSize="9px" cursor="pointer" whiteSpace="nowrap" onClick={() => toggleField(key)}>
                          {expandedFields.includes(key) ? "Less" : "More"}
                        </Text>
                      )}
                    </Box> */}
                  </Flex>
                );
              }}
              textAlign="center"
            />

            {/* POC */}
            {/* <Column header="POC" body={(row: any, index: number) => (<RevealField rowIndex={index} field="poc" value={row.pocName} />)} textAlign="center" /> */}
            <Column
              header="POC"
              body={(row: any, index: number) => {
                const key = `${row.leadId}-poc`;

                return (
                  <Flex align="center" justify="center">
                    <Box width="180px">
                      <RevealField rowIndex={index} field="poc" value={row.pocName} isExpanded={expandedFields.includes(key)} />
                    </Box>

                    {/* <Box width="40px">
                      {row.pocName?.length > 25 && (
                        <Text color="#4048D6" fontSize="9px" cursor="pointer" whiteSpace="nowrap" onClick={() => toggleField(key)}>
                          {expandedFields.includes(key) ? "Less" : "More"}
                        </Text>
                      )}
                    </Box> */}
                  </Flex>
                );
              }}
              textAlign="center"
            />

            {/* PHONE */}
            {/* <Column header="Phone Number" body={(row: any, index: number) => <RevealField rowIndex={index} field="contact" value={row.contact} />} textAlign="center" /> */}
            <Column header="Phone Number" body={(row: any, index: number) => (
              <RevealField rowIndex={index} field="contact" value={row.contact} />
            )}
              textAlign="center"
            />
            {/* EMAIL */}
            <Column header="Email" body={(row: any, index: number) => (
              <RevealField rowIndex={index} field="email" value={row.email} />
            )} textAlign="center" />

            <Column
              header="Website"
              body={(row: any, index: number) => {
                const canOpenWebsite =
                  row.isAccepted ||
                  hasPermission("LeadPool", "View Website Before Accept");

                return (
                  <RevealField
                    rowIndex={index}
                    field="websiteUrl"
                    value={row.websiteUrl}
                  >
                    {row.websiteUrl ? (
                      canOpenWebsite ? (
                        <Link
                          href={
                            row.websiteUrl.startsWith("http")
                              ? row.websiteUrl
                              : `https://${row.websiteUrl}`
                          }
                          isExternal
                          color="#2563EB"
                          textDecoration="underline"
                          maxW="180px"
                          display="block"
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                        >
                          {row.websiteUrl}
                        </Link>
                      ) : (
                        <Text
                          maxW="180px"
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                        >
                          {row.websiteUrl}
                        </Text>
                      )
                    ) : (
                      <Text>N/A</Text>
                    )}
                  </RevealField>
                );
              }}
            />

            <Column header="Assigned To" field="assignedToUser" />
            {/* <Column header="Source" field="source" /> */}
            <Column
              header="Lead Status"
              body={(row: any) => {
                const statusStyle = getStatusStyle(row.leadStatus);

                const isStatusDisabled = row.leadStatus === "Won" || row.leadStatus === "Lost" || !canUpdateLeadStatus;

                return (
                  <Box display="inline-flex" alignItems="center" bg={statusStyle.bg} color={statusStyle.color} px="12px" py="6px" borderRadius="20px" fontSize="13px" fontWeight="500" gap="6px"
                    cursor={isStatusDisabled ? "not-allowed" : "pointer"} opacity={isStatusDisabled ? 0.7 : 1} onClick={() => { if (!isStatusDisabled) { handleOpenStatusModal(row); } }}
                  >
                    <Text m={0}>
                      {row.leadStatus || "Lead Created"}
                    </Text>

                    {!isStatusDisabled && (
                      <Image src={ArrowIcon} boxSize="6px" />
                    )}
                  </Box>
                );
              }}
            />

            <Column header="Created By" field="createdBy" />
            {/* ASSIGNED DATE */}
            <Column
              header="Created At"
              body={(row: any) => row.createdAt ? showDateTime(row.createdAt) : "N/A"}
            />

            {/* ACTION */}
            <Column
              header="Action"
              body={(row: ILead) => {
                const isPending = row.isAccepted === null;
                const isAccepted = row.isAccepted === true;
                const isRejected = row.isAccepted === false;

                return (
                  <Flex align="center" gap={2} wrap="nowrap" width="max-content" >
                    {isAccepted && (
                      <Tooltip label={`Accepted: ${row.reason ? ` ${row.reason}` : ""}`} hasArrow>
                        <Flex
                          w="24px"
                          h="24px"
                          borderRadius="full"
                          bg="green.500"
                          color="white"
                          align="center"
                          justify="center"
                          cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                          _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                          onClick={() => {
                            if (canViewLeadAcceptanceHistory) {
                              NavigateLeadAssesment(row); // Calls API / opens Lead Acceptance History
                            }
                          }}
                        >
                          <CheckIcon boxSize={3} />
                        </Flex>
                      </Tooltip>
                    )}

                    {isRejected && (
                      <>
                        <Tooltip label={`Rejected${(row.disReason || (row as any).disqualifyReason) ? ` [${row.disReason || (row as any).disqualifyReason}]` : ""}${row.reason ? `: ${row.reason}` : ""}`} hasArrow>
                          <Flex
                            w="24px"
                            h="24px"
                            borderRadius="full"
                            bg="red.500"
                            color="white"
                            align="center"
                            justify="center"
                            cursor={canViewLeadAcceptanceHistory ? "pointer" : "default"}
                            _hover={canViewLeadAcceptanceHistory ? { opacity: 0.8 } : undefined}
                          >
                            <SmallCloseIcon boxSize={2.5} />
                          </Flex>
                        </Tooltip>
                        {(row.disReason || (row as any).disqualifyReason) && (
                          <Tooltip label={`Disqualify Reason: ${row.disReason || (row as any).disqualifyReason}`} hasArrow>
                            <Flex align="center" px={2.5} py={1} borderRadius="full" bg="orange.50"
                              color="orange.700" border="1px solid" borderColor="orange.200" fontSize="12px"
                              fontWeight="500" maxW="140px"
                            >
                              <Text isTruncated>{row.disReason || (row as any).disqualifyReason}</Text>
                            </Flex>
                          </Tooltip>
                        )}
                      </>
                    )}

                    {isPending && (
                      <Tooltip label="Pending Acceptance" hasArrow>
                        <Flex
                          w="24px"
                          h="24px"
                          borderRadius="full"
                          bg="orange.400"
                          color="white"
                          align="center"
                          justify="center"
                        >
                          <TimeIcon boxSize={3} />
                        </Flex>
                      </Tooltip>
                    )}


                    <Tooltip label="History" placement="bottom" hasArrow>
                      <Image src={HistoryIcon} cursor="pointer" boxSize="18px" onClick={() => handleHistoryLead(row)} />
                    </Tooltip>

                    <Tooltip
                      label={isLeadWon(row) ? "Won leads cannot be reassigned" : "Reassign Lead"}
                      placement="bottom"
                      hasArrow
                    >
                      {canReassign ? (
                        <Button
                          size="xs"
                          colorScheme="twitter"
                          variant="ghost"
                          p={1}
                          minW="28px"
                          h="28px"
                          isDisabled={isLeadWon(row)}
                          onClick={() => {
                            if (!isLeadWon(row)) {
                              handleOpenReassignModal(row);
                            }
                          }}
                        >
                          <span style={{ fontSize: "10px", lineHeight: 1 }}>👤⇋👤</span>
                        </Button>
                      ) : null}
                    </Tooltip>

                    {/* {canEdit && (
                    <Tooltip label="Edit Lead" placement="bottom" hasArrow>
                      <Button size="xs" colorScheme="blue" variant="ghost" p={1} minW="28px" h="28px" leftIcon={<EditIcon />} onClick={() => NavigateMyLeadEdit(row)} />
                    </Tooltip>
                  )} */}
                  </Flex>
                )
              }
              }
            />
          </CustomTable>
        </GridItem>
      </Grid>
      <Modal isOpen={isStatusOpen} onClose={handleCloseStatusModal} isCentered>
        <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
        <ModalContent borderRadius="12px" maxW="380px">
          <ModalHeader>Update Status</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <Box mb={4}>
              <Text className="font-poppins text_medium text_md" mb={1}>
                Select Status
              </Text>

              <Select
                value={selectedStatus?.id || ""}
                placeholder="Select status"
                borderRadius="8px"
                fontSize="13px"
                onChange={(e) => {
                  const selected = statusOptions.find((s) => s.id === Number(e.target.value));
                  setSelectedStatus(selected || null);
                  setSelectedStatusReason(null);
                }}
              >
                {statusOptions.map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.label}
                  </option>
                ))}
              </Select>
            </Box>

            {/* Status Reason */}
            {statusReasonOptions.length > 0 && (
              <Box mb={4}>
                <Text className="font-poppins text_medium text_md" mb={1}>
                  Status Reason <Text as="span" color="red.500">*</Text>
                </Text>

                <Select
                  value={selectedStatusReason?.id || ""}
                  placeholder="Select status reason"
                  borderRadius="8px"
                  fontSize="13px"
                  onChange={(e) => {
                    const selected = statusReasonOptions.find(
                      (s) => s.id === Number(e.target.value)
                    );
                    setSelectedStatusReason(selected || null);
                  }}
                >
                  {statusReasonOptions.map((reason) => (
                    <option key={reason.id} value={reason.id}>
                      {reason.label}
                    </option>
                  ))}
                </Select>
              </Box>
            )}
            <Box mb={2}>
              <Text className="font-poppins text_medium text_md" mb={1}>
                Description
              </Text>
              <Textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Enter description..." borderRadius="8px" fontSize="13px" />
            </Box>

            {/* {selectedStatus?.id === 16 && (
              <Box p={4} mb={4} bg="blue.50" borderRadius="10px" border="1px solid" borderColor="blue.200">
                <Text mb={3} fontSize="sm" fontWeight="600" color="blue.800" className="font-poppins">
                  Project Conversion Details
                </Text>
                <VStack spacing={3} align="stretch">
                  <Box>
                    <Text mb={1} fontSize="xs" fontWeight="600" color="gray.700" className="font-poppins">
                      Project Amount (₹) <Text as="span" color="red.500">*</Text>
                    </Text>
                    <Input
                      type="number"
                      bg="white"
                      borderRadius="8px"
                      placeholder="Enter project amount"
                      value={projectAmount}
                      onChange={(e: any) => setProjectAmount(e.target.value)}
                      className="font-poppins"
                      size="sm"
                    />
                  </Box>
                  <Box>
                    <Text mb={1} fontSize="xs" fontWeight="600" color="gray.700" className="font-poppins">
                      Project Duration <Text as="span" color="red.500">*</Text>
                    </Text>
                    <Input
                      type="number"
                      bg="white"
                      borderRadius="8px"
                      placeholder="Enter duration"
                      value={projectDuration}
                      onChange={(e: any) => setProjectDuration(e.target.value)}
                      className="font-poppins"
                      size="sm"
                    />
                  </Box>
                  <Box>
                    <Text mb={1} fontSize="xs" fontWeight="600" color="gray.700" className="font-poppins">
                      Duration Type <Text as="span" color="red.500">*</Text>
                    </Text>
                    <Select
                      bg="white"
                      borderRadius="8px"
                      value={projectDurationType}
                      onChange={(e: any) => setProjectDurationType(Number(e.target.value))}
                      className="font-poppins"
                      size="sm"
                    >
                      <option value={2}>Months</option>
                      <option value={1}>Days</option>
                      <option value={3}>Years</option>
                    </Select>
                  </Box>
                </VStack>
              </Box>
            )} */}
          </ModalBody>

          <ModalFooter gap={3}>
            <Button variant="ghost" onClick={handleCloseStatusModal}>
              Cancel
            </Button>
            <Button bg="#4048D6" _hover={{ bg: "#353CC4" }} color="white" onClick={handleUpdateStatus} isDisabled={!selectedStatus || statusLoading || (statusReasonOptions.length > 0 && !selectedStatusReason)}>
              Update
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isReassignOpen} onClose={() => { if (!reassignLoading) { setIsReassignOpen(false); } }}
        closeOnOverlayClick={!reassignLoading} isCentered >
        <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
        <ModalContent borderRadius="12px" maxW="400px">
          <ModalHeader fontSize="16px">Reassign Lead</ModalHeader>
          <ModalCloseButton isDisabled={reassignLoading} />

          <ModalBody>
            {/* Current assignee info */}
            <Box mb={4} p={3} bg="#F9FAFB" borderRadius="8px" border="1px solid #E4E7EC">
              <Text fontSize="12px" color="#667085" mb={1}>
                Currently Assigned To
              </Text>
              <Text fontSize="13px" fontWeight="600" color="#344054">
                {reassignLead?.assignedToUser ?? "Unassigned"}
              </Text>
            </Box>

            <Box mb={4}>
              <Text fontSize="14px" fontWeight="500" mb={2}>
                Assign To
              </Text>

              <Select value={selectedUserId ?? ""} placeholder="Select team member" borderRadius="8px" fontSize="13px" onChange={(e) => setSelectedUserId(Number(e.target.value))}>
                {userOptions.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </Select>
            </Box>

            {/* <Box mb={2}>
              <Text className="font-poppins text_medium text_md" mb={1}>
                Note (optional)
              </Text>
              <Textarea value={reassignNote} onChange={(e) => setReassignNote(e.target.value)} placeholder="Reason for reassignment..." borderRadius="8px" fontSize="13px" rows={3} />
            </Box> */}
          </ModalBody>

          <ModalFooter gap={3}>
            <Button variant="ghost" onClick={() => setIsReassignOpen(false)} isDisabled={reassignLoading} > Cancel </Button>

            <Button colorScheme="purple" onClick={handleReassign} isLoading={reassignLoading} loadingText="Reassigning..."
              isDisabled={!selectedUserId || reassignLoading || (
                selectedUserId === reassignLead?.assignedToUserId &&
                reassignLead?.isAccepted !== false
              )}
            >
              Reassign
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Multi Assign Modal */}


      <Modal isOpen={isMultiAssignOpen} onClose={() => { if (!multiReassignLoading) { setIsMultiAssignOpen(false); setMultiAssignRemarks(""); } }}
        closeOnOverlayClick={!multiReassignLoading}
        isCentered
      >
        <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(4px)" />
        <ModalContent borderRadius="12px" maxW="380px">
          <ModalHeader fontSize="16px">Reassign Leads</ModalHeader>
          <ModalCloseButton isDisabled={multiReassignLoading} />

          <ModalBody>
            <Box mb={4} p={3} bg="#F9FAFB" borderRadius="8px" border="1px solid #E4E7EC">
              <Text fontSize="12px" color="#667085" mb={1}>
                Selected Leads
              </Text>
              <Text fontSize="13px" fontWeight="600" color="#344054">
                {selectedLeads.length} Lead{selectedLeads.length > 1 ? "s" : ""} will be reassigned
              </Text>
            </Box>

            <Box mb={4}>
              <Text fontSize="14px" fontWeight="500" mb={2}>
                Assign To
              </Text>
              <Select value={multiAssignUserId ?? ""} placeholder="Select team member" borderRadius="8px" fontSize="13px" onChange={(e) => setMultiAssignUserId(Number(e.target.value))}>
                {userOptions.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </Select>
            </Box>

            <Box mb={2}>
              <Text fontSize="14px" fontWeight="500" mb={2}>
                Description / Remarks
              </Text>
              <Textarea
                value={multiAssignRemarks}
                onChange={(e) => setMultiAssignRemarks(e.target.value)}
                placeholder="Enter description or remarks..."
                borderRadius="8px"
                fontSize="13px"
                rows={3}
              />
            </Box>
          </ModalBody>

          <ModalFooter gap={3}>
            <Button variant="ghost" onClick={() => { setIsMultiAssignOpen(false); setMultiAssignRemarks(""); }} isDisabled={multiReassignLoading} > Cancel </Button>

            <Button colorScheme="purple" onClick={handleMultiAssign} isLoading={multiReassignLoading} loadingText="Reassigning..."
              isDisabled={!multiAssignUserId || selectedLeads.length === 0 || multiReassignLoading} >
              Reassign
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </MyDiv>
  );
};

export default MyTeamLeadList;
